import React from 'react';
import { Div, DivProps } from '@kizi/core-components';
import { DataSummary } from './DataSummary';

export interface AddressDisplayProps extends DivProps {
  street: string;
  streetNumber: string;
  streetNumberAddition: string;
  zipCode: string;
  city: string;
}

export const AddressDisplay: React.FC<AddressDisplayProps> = ({
  street,
  streetNumber,
  streetNumberAddition,
  zipCode,
  city,
  ...restProps
}) => {
  const fieldMap = [
    {
      _label: 'Straatnaam',
      _fieldName: '*.street',
      _value: street,
    },
    {
      _label: 'Huisnummer',
      _fieldName: '*.housenumber',
      _value: streetNumber,
    },
    {
      _label: 'Toevoeging',
      _fieldName: '*.housenumberaddition',
      _value: streetNumberAddition,
    },
    {
      _label: 'Postcode',
      _fieldName: '*.postcode',
      _value: zipCode,
    },
    {
      _label: 'Woonplaats',
      _fieldName: '*.city',
      _value: city,
    },
  ];
  return (
    <Div {...restProps}>
      <DataSummary title="Leveringsadres" description="" fields={fieldMap} />
    </Div>
  );
};
